import { ErrorState } from "@volca/ui/components/ui/error-state";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { isProductEnabled } from "@/business/product-access";
import { useBusiness } from "@/core/business";
import { useBusinessProducts } from "@/core/business/use-business-products";
import { TechnicianPayrollPage } from "./technician-payroll-page";
import { TechnicianPayrollUnavailable } from "./technician-payroll-unavailable";

export const TechnicianPayrollRoute = () => {
  const { isError } = useBusiness();
  const { settings, isLoading, hasValidSettings } = useBusinessProducts();
  if (isLoading) {
    return <Spinner layout="centered" aria-label="Loading payroll access" />;
  }

  if (isError || !hasValidSettings) {
    return (
      <ErrorState
        illustration="none"
        title="Could not load payroll access"
        description="Refresh the page and try again."
      />
    );
  }

  if (!isProductEnabled(settings, "payroll")) {
    return <TechnicianPayrollUnavailable />;
  }

  return <TechnicianPayrollPage />;
};
